// extracted by mini-css-extract-plugin
module.exports = {"suggestion":"styles-module__suggestion___1qFS6","active":"styles-module__active___1UZyN"};